import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { SmartContext } from '../../library/Core/SmartContext';
import smartReducer from '../../library/Core/SmartReducer';
import { ControlOnChangeArguments, DispatchEvent, State } from '../../library/Core/SmartTypes';
import WidgetConfigurationLayout from './WidgetConfigurationLayout';
import PageBuilder from '../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../library/Core/GlobalContext';
import { arrayColumn, getAssociativeArray, getDomainValueForCode, getMultiAssociativeArray, isEmpty, triggerGridDataOnChange } from '../../library/Core/SmartFunctions';
import { axiosClient } from '../../library/Service/axiosClient';
import { handleAddNew, handlePreview, handleReset, handleSave, handleViewList } from './WidgetConfigurationActions';
import ListPopup from './ListPopup';
import AddPopup from './AddPopup';
import SessionContext from '../../library/Core/SessionContext';
import useManagementDashboard from '../management/dashboard/useManagementDashboard';
import FormListService from './FormListService';
import { getinstituteList } from '../../library/Service/domainService';
import { fetchProgramOptions, toProgramDomainElements } from './WidgetProgramService';


const WidgetConfiguration = () => {
    const navigate = useNavigate();
    const { globalState } = useContext(GlobalContext);
    const { sessionState } = useContext(SessionContext);
    const { allForms } = FormListService();
    const { getWidgetCampuses } = useManagementDashboard();
    const campuses = getWidgetCampuses();
    const [instituteList, setinstituteList] = useState(getinstituteList('INSTITUTE_GROUP_CODE', campuses));

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        internal: internal,
        data: data,
        actions: {
            RESET: handleReset,
            SAVE: handleSave,
            PREVIEW: handlePreview,
            REDIRECT: navigate,
            metricEntity: onCareerChange,
            metricEntity2: onMetricEntity2Change,
            statMetricEntity: onStatMetricEntityChange,
            statMetricType: onStatMetricEntityChange,
            value: onCareerChange,
            metricType: onCareerChange,
            programLevel: onProgramLevelChange,
            VIEWLIST: handleViewList,
            sourceType: onSourceTypeChange,
            ADDNEW: handleAddNew,
            instituteList: onInstituteListChange,
            programId: onProgramChange,
        },
    } as any);
    let {id, code} = useParams();
    const isEditing = !!id;
    if ( typeof code == 'undefined') {
        code = '';
    }
    useEffect(() => {
        let popupData;
        switch ( code ) {
            case 'top_companies':
                if ( data?.widgetData?.sourceType != 'external_data' ) {
                    popupData = getMultiAssociativeArray(state?.internal?.top_company_list, 'industryCode')
                    data.popupData = popupData;
                }
                break;
            
            case 'top_colleges':
                if ( data?.widgetData?.sourceType != 'external_data' ) {
                    popupData = getMultiAssociativeArray(state?.internal?.top_college_list, 'countryCode')
                    data.popupData = popupData;
                }
                break;

            case 'directory_stats':
                if ( isEmpty (data.widgetData.largeHeading) ) {
                    let domainCode =  'SCHOOL_GROUP';
                    if ( sessionState?.primaryInstitute == sessionState?.instituteGroupId ) {
                        domainCode = 'INSTITUTE_DOMAIN';
                    }
    
                    const headingPrefix = getDomainValueForCode(sessionState?.instituteGroupId as any, domainCode, {domain:globalState.domain} as State);
                    data.widgetData.largeHeading = `${headingPrefix} Alumni Statistics`;
                }
                
                break;
        }

        const fetchData = async () => {
            try {
                if (isEditing) {
                    dispatch({
                        type: 'DATA_INIT',
                        payload: {
                            formConfig, //: {...formConfig, "buttons": "SAVE,PREVIEW"},
                            data: data,
                            domain: new Map([...globalState.domain]),
                            internal,
                            routeInfo,
                        },
                    });
                    dispatch({ type: 'RESET_VALIDATION_ERRORS' });
                } else {
                    dispatch({
                        type: 'DATA_INIT',
                        payload: {
                            formConfig,
                            // data: {
                            //     ...data,
                            //     // widgetData: {
                            //     //     heading: ""
                            //     // },
                            //     // metricData: []
                            // },
                            data,
                            domain: new Map([...globalState.domain]),
                            internal,
                            routeInfo,
                        },
                    });
                }    
            } catch (error) {
                console.error('Error fetching program data:', error);
            }
            dispatch({
                type: 'SET_DOMAIN',
                payload: { key: 'INSTITUTE_GROUP_CODE', value: instituteList },
            });

            const userObjMount = JSON.parse(localStorage.getItem('user') || '{}');
            const isSuperAdminMount = userObjMount?.role === 'SUPER_ADMIN' || userObjMount?.userTypeCode === 'SUPER_ADMIN';
            const widgetGroupMount = isSuperAdminMount ? (localStorage.getItem('widgetGroup') || '') : '';
            const widgetInstituteMount = isSuperAdminMount ? (localStorage.getItem('widgetInstitute') || '') : '';
            const currentInstituteId = data?.widgetData?.instituteList || (!widgetGroupMount ? widgetInstituteMount : '');
            const mountGroupId = isSuperAdminMount ? widgetGroupMount : (userObjMount?.instituteGroupId || '');
            const mountProgramId = data?.widgetData?.programId ?? null;

            const [FromWthInstitute, programOptions] = await Promise.all([
                allForms(currentInstituteId || '', mountProgramId || null),
                fetchProgramOptions(currentInstituteId || null, mountGroupId || null),
            ]);

            console.log(FromWthInstitute, 'FORM_WITH_INSTITUTE')
            dispatch({
                type: "SET_DOMAIN",
                payload: { key: "FORM_WITH_INSTITUTE", value: FromWthInstitute || [] },
            });
            dispatch({
                type: 'SET_DOMAIN',
                payload: { key: 'PROGRAM_LIST', value: toProgramDomainElements(programOptions) },
            });
        };
    
        fetchData();
    }, []);

    // Re-populate INSTITUTE_GROUP_CODE domain after DATA_INIT has set state.domain
    // and whenever the underlying institute domain changes. SET_DOMAIN is a no-op
    // before DATA_INIT runs, so gating on !isDataLoading is required.
    // For SUPER_ADMIN: if a specific institute was picked on the listing-page filter
    // (localStorage.widgetInstitute), narrow the dropdown to that single institute
    // instead of showing all institutes in the group.
    useEffect(() => {
        if (state.flags.isDataLoading) return;

        const isSuperAdminUser = sessionState?.userTypeCode === 'SUPER_ADMIN';
        const widgetGroupFromList = isSuperAdminUser ? (localStorage.getItem('widgetGroup') || '') : '';
        const widgetInstituteFromList = isSuperAdminUser ? (localStorage.getItem('widgetInstitute') || '') : '';

        // SUPER_ADMIN: if user picked ONLY an institute (no group) on the listing
        // filter, scope the dropdown to that single institute (sourced directly
        // from INSTITUTE_DOMAIN to bypass is_published). Otherwise show the full
        // group list (group + optional institute pre-selection case).
        const freshCampuses = getWidgetCampuses();
        let scopedCampuses = freshCampuses;
        if (widgetInstituteFromList && !widgetGroupFromList) {
            const inst = (globalState.domain.get('INSTITUTE_DOMAIN') as any[])
                ?.find((item: any) => String(item.code) === String(widgetInstituteFromList));
            scopedCampuses = inst ? [{ label: inst.value, value: inst.code }] : freshCampuses;
        }
        const freshList = getinstituteList('INSTITUTE_GROUP_CODE', scopedCampuses);
        dispatch({
            type: 'SET_DOMAIN',
            payload: { key: 'INSTITUTE_GROUP_CODE', value: freshList },
        });

        // SUPER_ADMIN with group + institute filter: pre-populate the chosen institute
        // in the form (don't hide the dropdown — user may want to switch institutes).
        if (isSuperAdminUser && widgetInstituteFromList && widgetGroupFromList && state.data?.widgetData) {
            if (!state.data.widgetData.instituteList) {
                dispatch({
                    type: 'CONTROL_VALUE_CHANGE',
                    payload: { dataKey: 'widgetData.instituteList', value: widgetInstituteFromList },
                });
            }
        }

        // Auto-select + hide only when the dropdown has exactly 1 option
        // (INSTITUTE_ADMIN with a single institute, or a group with 1 institute).
        if (freshList?.length === 1 && state.data?.widgetData) {
            const onlyInstituteCode = freshList[0].code;
            if (state.data.widgetData.instituteList !== onlyInstituteCode) {
                dispatch({
                    type: 'CONTROL_VALUE_CHANGE',
                    payload: { dataKey: 'widgetData.instituteList', value: onlyInstituteCode },
                });
            }
            const currentConfig = state.formConfig as any;
            let needsPatch = false;
            const patchedConfig = currentConfig ? JSON.parse(JSON.stringify(currentConfig)) : null;
            patchedConfig?.sectionRepository?.forEach((section: any) => {
                section.controlGroup?.forEach((control: any) => {
                    if (control.id === 'instituteList' && control.hideExpression !== '1') {
                        control.hideExpression = '1';
                        needsPatch = true;
                    }
                });
            });
            if (needsPatch && patchedConfig) {
                dispatch({ type: 'FORM_CONFIG', payload: patchedConfig });
            }
        }
    }, [state.flags.isDataLoading, globalState.domain, sessionState?.institutes, sessionState?.userTypeCode, state.formConfig]);

    useEffect(() => {
        if (isEditing) {
            let btnList = "RESET,SAVE,PREVIEW";
            switch ( code ) {
                case 'top_companies':
                case 'top_colleges':
                    btnList = "SAVE,PREVIEW";
                    break;
            }
            dispatch({ type: 'FORM_CONFIG', payload: { ...formConfig, "buttons": btnList } });
            
        }
        
    }, [isEditing]);

    useEffect(() => {

        if ( isEditing ) {
            return;
        }

        const allowedWidgets = ['top_careers', 'top_study_country']

        if (!code || !state?.internal?.[code] || !allowedWidgets.includes(code)) {
            return;
        }

        let ctr = 0;
        const metricData = state?.data?.metricData;

        if (!Array.isArray(metricData)) {
            console.error('metricData is not an array', metricData);
            return;
        }

        const updatedMetricData = metricData.map(item => ({ ...item }));
        state.internal[code].forEach((rec: any, idx: any) => {
            if (rec?.metricEntityCode == 0 || ctr >= 4) return;
            if (updatedMetricData[ctr]) {
                updatedMetricData[ctr]['metricEntity'] = rec?.metricEntityCode;
                ctr++;
            }
        });

        dispatch({
            type: 'REFRESH_DATA',
            payload: {
                data: {...state.data, metricData: updatedMetricData}
            },
        });

        setTimeout(() => {
            triggerGridDataOnChange(updatedMetricData, "metricData", "metricEntity");
        }, 500);
    }, [state?.internal?.top_careers, state?.internal?.top_study_country])

    
    useEffect(() => {

        if ( isEditing ) {
            return;
        }

        const allowedWidgets = ['directory_stats']

        if (!code || !state?.internal?.[code] || !allowedWidgets.includes(code)) {
            return;
        }

        let ctr = 0;
        const metricData = state?.data?.metricData;

        if (!Array.isArray(metricData)) {
            console.error('metricData is not an array', metricData);
            return;
        }

        const updatedMetricData = metricData.map(item => ({ ...item }));
        updatedMetricData[0]['statMetricEntity'] = 'joined_alumni';

        dispatch({
            type: 'REFRESH_DATA',
            payload: {
                data: {...state.data, metricData: updatedMetricData}
            },
        });

        setTimeout(() => {
            triggerGridDataOnChange(updatedMetricData, "metricData", "metricEntity");
        }, 500);
    }, [state?.internal?.directory_stats])


    useEffect(() => {
        setTimeout(() => {
            switch ( code ) {
                case 'top_companies':
                case 'top_colleges':
                   triggerGridDataOnChange(state?.data?.metricData, "metricData", "metricEntity2");
                    break;
                
                default:
                    triggerGridDataOnChange(state?.data?.metricData, "metricData", "metricEntity");
            }          
        }, 500);
    }, [state?.data?.metricData, state?.data?.widgetData?.sourceType])

    useEffect(() => {
        if ( isEditing ) {
            return;
        }

        const allowedWidgets = ['top_companies', 'top_colleges']

        if (!code || !state?.internal?.[code] || !allowedWidgets.includes(code)) {
            return;
        }

        let ctr = 0;
        const metricData = state?.data?.metricData ?? [];

        if (!Array.isArray(metricData)) {
            console.error('metricData is not an array', metricData);
            return;
        }

        const updatedMetricData = metricData.map(item => ({ ...item }));
        state.internal[code].forEach((rec: any, idx: any) => {
            if (rec?.metricEntityCode == 0 || ctr >= 1) return;
            if (updatedMetricData[ctr]) {
                updatedMetricData[ctr]['metricEntity2'] = rec?.metricEntityCode;
                ctr++;
            } else {
                updatedMetricData[ctr] = {
                    "metricEntity2": rec?.metricEntityCode
                }
                ctr++;
            }
        });

        dispatch({
            type: 'REFRESH_DATA',
            payload: {
                data: {...state.data, metricData: updatedMetricData}
            },
        });

        setTimeout(() => {
            triggerGridDataOnChange(updatedMetricData, "metricData", "metricEntity2");
        }, 500);
    }, [state?.internal?.top_companies, state?.internal?.top_colleges])

    function onCareerChange(props: ControlOnChangeArguments) {
        if ( isEmpty(props.state.internal) ) {
            return false;
        }

        // Bail out if parentDataKey is missing or its row in state.data.metricData
        // doesn't exist. Without this guard, dispatching `${parentDataKey}.value`
        // throws "Cannot set properties of undefined (setting 'value')" — happens
        // when triggerGridDataOnChange synthesizes events on rows that don't map
        // to a real state row (e.g. INSTITUTE_ADMIN with single institute, where
        // grid display rows can outnumber the saved metricData entries).
        if (!props.parentDataKey || isEmpty(props.row)) {
            return;
        }

        let metricEntity = props?.value;
        let value = (!isNaN(props?.value)  && props?.value > 0) ? props?.value : 0;
        let metricType= props?.value;
        
        if (props.control.id != 'metricType') {
            metricType = props?.row?.metricType;
        }

        if (props.control.id != 'value') {
            value = props?.row?.value;   
        }
        
        if (props.control.id != 'metricEntity') {
            metricEntity = props?.row?.metricEntity;   
        }

        if (!code || !props?.state?.internal[code]) {
            return;
        }

        const errorMessages = [] as any[];
        let countData = getAssociativeArray(props.state?.internal?.[props.state?.internal?.widget_code], 'metricEntityCode');
        const totalAlumniCount = props.state?.internal?.[code].reduce((sum: any, item: any) => sum + item.userCount, 0);

        let currentCareerUserCount = countData[metricEntity]?.userCount ?? 0;
        let currentPercentage: any = 0;
        let totalPercentage: any = 0;
        
        currentPercentage = Math.round((currentCareerUserCount/totalAlumniCount)*100)

        if (metricType == 'override') {
            currentPercentage = (!isNaN(value)  && value > 0) ? value : 0;
        }

        currentPercentage = parseFloat(currentPercentage);

        props.state.data?.metricData?.map((data: any) => {
            if ( ! isEmpty(data?.metricEntity) && ! isEmpty(data?.value) && data?.metricEntity != metricEntity ) {
                totalPercentage += parseFloat(data.value);
                // if ( data?.metricEntity > 0 ) totalCareerSelected++; // skipping the free text/other careers as separate section as calculating other career separately;
            }
        })

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `${props.parentDataKey}.value`,
                value: currentPercentage,
            },
        });

        totalPercentage += currentPercentage;
        let remainingValue: any = 100-parseFloat(totalPercentage); // calculating other career percentage;
        let remainingValueDisp = remainingValue%1 == 0 ? remainingValue.toFixed(0) : remainingValue.toFixed(2); // calculating other career percentage;

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `widgetData.other`,
                value:  remainingValueDisp
            },
        });
    };

    async function onSourceTypeChange(props: ControlOnChangeArguments) {
        if ( isEmpty(props.state.internal) ) {
            return false;
        }        
        const sourceType = props.value;
        let popupData;
        
        if ( sourceType == 'external_data' ) {
            dispatch({
                type: 'REFRESH_DATA',
                payload: {
                    data: {...props.state.data, popupData: {}, widgetData: {...props.state.data.widgetData, otherList: []}}
                },
            });

        } else {
            if ( isEmpty(props.state.data.widgetData?.largeHeading) ) {
                return;
            }

            if ( code == 'top_companies' ) {
                popupData = getMultiAssociativeArray(props.state?.internal?.top_company_list, 'industryCode')
            }
            if ( code == 'top_colleges' ) {
                popupData = getMultiAssociativeArray(props.state?.internal?.top_college_list, 'countryCode')
            }

            dispatch({
                type: 'REFRESH_DATA',
                payload: {
                    data: {...props.state.data, popupData: popupData, widgetData: {...props.state.data.widgetData, otherList: []}}
                },
            });
        }
    };

    async function onMetricEntity2Change(props: ControlOnChangeArguments) {
        if ( isEmpty(props.state.internal) ) {
            return false;
        }

        if ( !code || !props?.state?.internal[code] ) {
            return;
        }

        // Bail out if parent row doesn't exist in state — see comment in onCareerChange.
        if (!props.parentDataKey || isEmpty(props.row)) {
            return;
        }

        const metricEntity  = props?.value;
        const sourceType    = props?.state?.data?.widgetData?.sourceType ?? "";
        let currentDisplayCount    = 0;
        let currenrDisplayValue    = '';
        let otherCount      = 0;
        let otherDisplay    = '';
        let entityListCode  = '';        
        let displayEntity;
        let entityKey: any;
        let metricCode: any;

        currentDisplayCount =  props?.state?.data?.popupData?.[metricEntity]?.length ?? 0;

        switch ( code ) {
            case 'top_companies':
                displayEntity = "Companies";
                entityListCode = 'top_company_list';
                entityKey = 'companyId';
                metricCode = 'industryCode';
                
                break;
        
            case 'top_colleges':
                displayEntity = "Colleges";
                entityListCode = 'top_college_list';
                entityKey = 'instituteId';
                metricCode = 'countryCode';

                break;
            
            default:
                displayEntity = "";
        }

        currenrDisplayValue    = `${currentDisplayCount} ${displayEntity}`

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `${props.parentDataKey}.metricCount`,
                value: currenrDisplayValue,
            },
        });

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `${props.parentDataKey}.cnt`,
                value: currentDisplayCount,
            },
        });

        let otherList: any = [];
        if ( sourceType != 'external_data' ) {
            let selectedItems = arrayColumn(props.state.data.metricData,'metricEntity2');        
            let entityIds: any = [];
            // Iterate over the keys of popupData
            for (const key in props.state.data.popupData) {
                if (Array.isArray(props.state.data.popupData[key])) {
                    const filteredArray = props.state.data.popupData[key].filter((rec: any) => {
                        let filterFlag = !selectedItems.includes(String(rec?.[metricCode])) && !entityIds.includes(rec?.[entityKey]);
                        entityIds.push(rec?.[entityKey]);
                        return filterFlag;
                    });

                    otherList = otherList.concat(filteredArray);
                }
            }
        } else {
            otherList = props.state.data.widgetData.otherList;
        }

        // otherCount = totalCompanies-totalSelected;
        otherCount = otherList.length ?? 0;
        otherDisplay = `${otherCount} ${displayEntity}`
        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `widgetData.otherDisp`,
                value:  otherDisplay
            },
        });

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `widgetData.other`,
                value:  otherCount
            },
        });


        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `widgetData.otherList`,
                value:  otherList
            },
        });

    };
    
    async function onStatMetricEntityChange(props: ControlOnChangeArguments) {
        if ( isEmpty(props.state.internal) ) {
            return false;
        }

        if ( !code || !props?.state?.internal[code] ) {
            return;
        }

        // Bail out if parent row doesn't exist in state — see comment in onCareerChange.
        if (!props.parentDataKey || isEmpty(props.row)) {
            return;
        }

        const METRIC_ENTITY_MAP: any = {
            joined_alumni: 'totalAccessibleAlumni',
            different_career_chosen: 'differentCareer',
            companies_represented: 'companiesRepresented',
            countries_represented: 'countriesRepresented',
            alumni_at_top_colleges: 'topColleges',
            alumni_at_top_companies: 'topCompanies',
            scholarship_received: 'scholarshipReceived'
        }
        
        let metricEntity = props?.value;
        let metricType= props?.value;
        let value = "";

        if (props.control.id != 'statMetricType') {
            metricType = props?.row?.statMetricType;
        }
        
        if (props.control.id != 'statMetricEntity') {
            metricEntity = props?.row?.statMetricEntity;   
        }

        if (metricType == 1) {
            value = props.state.internal.directory_stats?.[0]?.[METRIC_ENTITY_MAP?.[metricEntity]];
        }

        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: {
                dataKey: `${props.parentDataKey}.displayValue`,
                value: value,
            },
        });

    };

    function rebuildMetricDataFromCounts(currentMetricData: any, internalData: any, widgetCode: string) {
        // Always return an array so we never dispatch undefined into state.data.metricData,
        // which would break any subsequent metricData[X].value writes from grid handlers.
        const safeCurrent = Array.isArray(currentMetricData) ? currentMetricData : [];
        if (!Array.isArray(internalData)) {
            return safeCurrent;
        }
        const directoryStatsMetricMap: any = {
            joined_alumni: 'totalAccessibleAlumni',
            different_career_chosen: 'differentCareer',
            companies_represented: 'companiesRepresented',
            countries_represented: 'countriesRepresented',
            alumni_at_top_colleges: 'topColleges',
            alumni_at_top_companies: 'topCompanies',
            scholarship_received: 'scholarshipReceived'
        };

        if (widgetCode === 'directory_stats') {
            return safeCurrent.map((item: any) => ({
                ...item,
                displayValue: item?.statMetricType === 1
                    ? internalData?.[0]?.[directoryStatsMetricMap?.[item?.statMetricEntity]]
                    : item?.displayValue,
            }));
        }

        const fetchedData = internalData.filter((rec: any) => String(rec?.metricEntityCode) !== '0');

        if (widgetCode === 'top_careers' || widgetCode === 'top_study_country') {
            const rowLimit = safeCurrent.length || 4;
            return fetchedData.slice(0, rowLimit).map((rec: any, index: number) => ({
                ...(safeCurrent[index] || {}),
                metricEntity: rec?.metricEntityCode,
            }));
        } else if (widgetCode === 'top_companies' || widgetCode === 'top_colleges') {
            const rowLimit = safeCurrent.length || 1;
            return fetchedData.slice(0, rowLimit).map((rec: any, index: number) => ({
                ...(safeCurrent[index] || {}),
                metricEntity2: rec?.metricEntityCode,
            }));
        }
        return safeCurrent;
    }

    async function onProgramLevelChange(props: ControlOnChangeArguments) {
        if (!code) return;

        const programLevel = props?.value;
        const userObj = JSON.parse(localStorage.getItem('user') || '{}');
        const isSuperAdminUser = userObj?.role === 'SUPER_ADMIN' || userObj?.userTypeCode === 'SUPER_ADMIN';
        const widgetGroupFromList = isSuperAdminUser ? (localStorage.getItem('widgetGroup') || '') : '';
        const widgetInstituteFromList = isSuperAdminUser ? (localStorage.getItem('widgetInstitute') || '') : '';
        const instituteId = props?.state?.data?.widgetData?.instituteList || (!widgetGroupFromList ? widgetInstituteFromList : '');
        const instituteGroupId = isSuperAdminUser
            ? widgetGroupFromList
            : (userObj?.instituteGroupId || '');
        const programId = props?.state?.data?.widgetData?.programId;
        const queryParts: string[] = [];
        if (instituteId) queryParts.push(`instituteId=${instituteId}`);
        if (instituteGroupId) queryParts.push(`instituteGroupId=${instituteGroupId}`);
        if (programId) queryParts.push(`programId=${programId}`);
        const instituteQry = queryParts.length ? `?${queryParts.join('&')}` : '';

        const endpointMap: any = {
            top_careers: [{ key: 'top_careers', url: `get-top-career-counts/${programLevel}` }],
            top_study_country: [{ key: 'top_study_country', url: `get-top-study-country-counts/${programLevel}` }],
            top_colleges: [
                { key: 'top_colleges', url: `get-top-college-counts/${programLevel}` },
                { key: 'top_college_list', url: `get-top-college-list/${programLevel}` },
            ],
        };

        const endpoints = endpointMap[code];
        if (!endpoints) return;

        const results: any = {};
        for (const ep of endpoints) {
            const response = await axiosClient().get(`${process.env.REACT_APP_WIDGET_API_SERVER}/widgetInfo/${ep.url}${instituteQry}`);
            results[ep.key] = response.data;
            dispatch({
                type: 'SET_INTERNAL_STATE',
                payload: { key: ep.key, value: response.data },
            });
        }

        if (code === 'top_colleges' && results.top_college_list) {
            const popupData = getMultiAssociativeArray(results.top_college_list, 'countryCode');
            props.dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'popupData', value: popupData },
            });
        }

        const newMetricData = rebuildMetricDataFromCounts(props.state.data?.metricData, results[code], code);
        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: { dataKey: 'metricData', value: newMetricData },
        });

        setTimeout(() => {
            switch (code) {
                case 'top_companies':
                case 'top_colleges':
                    triggerGridDataOnChange(newMetricData, 'metricData', 'metricEntity2');
                    break;
                default:
                    triggerGridDataOnChange(newMetricData, 'metricData', 'metricEntity');
            }
        }, 500);
    }

    async function onInstituteListChange(props: ControlOnChangeArguments) {
        if (!code) return;

        const userObj = JSON.parse(localStorage.getItem('user') || '{}');
        const isSuperAdminUser = userObj?.role === 'SUPER_ADMIN' || userObj?.userTypeCode === 'SUPER_ADMIN';
        const widgetGroupFromList = isSuperAdminUser ? (localStorage.getItem('widgetGroup') || '') : '';
        const widgetInstituteFromList = isSuperAdminUser ? (localStorage.getItem('widgetInstitute') || '') : '';
        const instituteId = props?.value || props?.state?.data?.widgetData?.instituteList || (!widgetGroupFromList ? widgetInstituteFromList : '');
        const instituteGroupId = isSuperAdminUser
            ? widgetGroupFromList
            : (userObj?.instituteGroupId || '');
        const queryParts: string[] = [];
        if (instituteId) queryParts.push(`instituteId=${instituteId}`);
        if (instituteGroupId) queryParts.push(`instituteGroupId=${instituteGroupId}`);
        const instituteQry = queryParts.length ? `?${queryParts.join('&')}` : '';
        const programLevel = props?.state?.data?.widgetData?.programLevel ?? 'UG';

        const endpointMap: any = {
            top_careers: [{ key: 'top_careers', url: `get-top-career-counts/${programLevel}` }],
            top_study_country: [{ key: 'top_study_country', url: `get-top-study-country-counts/${programLevel}` }],
            top_industries: [{ key: 'top_industries', url: 'get-top-industry-counts' }],
            alumni_occupation: [{ key: 'alumni_occupation', url: 'get-occupation-counts' }],
            top_companies: [
                { key: 'top_companies', url: 'get-top-company-counts' },
                { key: 'top_company_list', url: 'get-top-company-list' },
            ],
            top_colleges: [
                { key: 'top_colleges', url: `get-top-college-counts/${programLevel}` },
                { key: 'top_college_list', url: `get-top-college-list/${programLevel}` },
            ],
            directory_stats: [{ key: 'directory_stats', url: 'get-directory-stats' }],
            current_location_country: [{ key: 'current_location_country', url: 'get-current-location-country-counts' }],
        };

        // Refresh the form list (FORM_WITH_INSTITUTE) so the formlist dropdown
        // reflects forms relevant to the newly selected institute.
        try {
            const refreshedForms = await allForms(instituteId || '', null);
            dispatch({
                type: 'SET_DOMAIN',
                payload: { key: 'FORM_WITH_INSTITUTE', value: refreshedForms || [] },
            });
            props.dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'widgetData.formlist', value: null },
            });
        } catch (err) {
            console.error('Error refreshing FORM_WITH_INSTITUTE:', err);
        }

        const programOptions = await fetchProgramOptions(instituteId || null, instituteGroupId || null);
        dispatch({
            type: 'SET_DOMAIN',
            payload: { key: 'PROGRAM_LIST', value: toProgramDomainElements(programOptions) },
        });
        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: { dataKey: 'widgetData.programId', value: null },
        });

        const endpoints = endpointMap[code];
        if (!endpoints) return;

        const results: any = {};
        for (const ep of endpoints) {
            const response = await axiosClient().get(`${process.env.REACT_APP_WIDGET_API_SERVER}/widgetInfo/${ep.url}${instituteQry}`);
            results[ep.key] = response.data;
            dispatch({
                type: 'SET_INTERNAL_STATE',
                payload: { key: ep.key, value: response.data },
            });
        }

        if (code === 'top_companies' && results.top_company_list) {
            const popupData = getMultiAssociativeArray(results.top_company_list, 'industryCode');
            props.dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'popupData', value: popupData },
            });
        }
        if (code === 'top_colleges' && results.top_college_list) {
            const popupData = getMultiAssociativeArray(results.top_college_list, 'countryCode');
            props.dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'popupData', value: popupData },
            });
        }

        const newMetricData = rebuildMetricDataFromCounts(props.state.data?.metricData, results[code], code);
        props.dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: { dataKey: 'metricData', value: newMetricData },
        });

        setTimeout(() => {
            switch (code) {
                case 'top_companies':
                case 'top_colleges':
                    triggerGridDataOnChange(newMetricData, 'metricData', 'metricEntity2');
                    break;
                case 'directory_stats':
                    triggerGridDataOnChange(newMetricData, 'metricData', 'statMetricEntity');
                    break;
                default:
                    triggerGridDataOnChange(newMetricData, 'metricData', 'metricEntity');
            }
        }, 500);
    }

    async function onProgramChange(props: ControlOnChangeArguments) {
        if (!code) return;

        const programId = props?.value;
        const userObj = JSON.parse(localStorage.getItem('user') || '{}');
        const isSuperAdminUser = userObj?.role === 'SUPER_ADMIN' || userObj?.userTypeCode === 'SUPER_ADMIN';
        const widgetGroupFromList = isSuperAdminUser ? (localStorage.getItem('widgetGroup') || '') : '';
        const widgetInstituteFromList = isSuperAdminUser ? (localStorage.getItem('widgetInstitute') || '') : '';
        const instituteId = props?.state?.data?.widgetData?.instituteList || (!widgetGroupFromList ? widgetInstituteFromList : '');
        const instituteGroupId = isSuperAdminUser
            ? widgetGroupFromList
            : (userObj?.instituteGroupId || '');
        const programLevel = props?.state?.data?.widgetData?.programLevel ?? 'UG';
        const queryParts: string[] = [];
        if (instituteId) queryParts.push(`instituteId=${instituteId}`);
        if (instituteGroupId) queryParts.push(`instituteGroupId=${instituteGroupId}`);
        if (programId) queryParts.push(`programId=${programId}`);
        const instituteQry = queryParts.length ? `?${queryParts.join('&')}` : '';

        // Refresh enquiry form list filtered by the selected program.
        try {
            const refreshedForms = await allForms(instituteId || '', programId || null);
            dispatch({
                type: 'SET_DOMAIN',
                payload: { key: 'FORM_WITH_INSTITUTE', value: refreshedForms || [] },
            });
            props.dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'widgetData.formlist', value: null },
            });
        } catch (err) {
            console.error('Error refreshing FORM_WITH_INSTITUTE:', err);
        }

        const endpointMap: any = {
            top_careers: [{ key: 'top_careers', url: `get-top-career-counts/${programLevel}` }],
            top_study_country: [{ key: 'top_study_country', url: `get-top-study-country-counts/${programLevel}` }],
            top_industries: [{ key: 'top_industries', url: 'get-top-industry-counts' }],
            alumni_occupation: [{ key: 'alumni_occupation', url: 'get-occupation-counts' }],
            top_companies: [
                { key: 'top_companies', url: 'get-top-company-counts' },
                { key: 'top_company_list', url: 'get-top-company-list' },
            ],
            top_colleges: [
                { key: 'top_colleges', url: `get-top-college-counts/${programLevel}` },
                { key: 'top_college_list', url: `get-top-college-list/${programLevel}` },
            ],
            directory_stats: [{ key: 'directory_stats', url: 'get-directory-stats' }],
            current_location_country: [{ key: 'current_location_country', url: 'get-current-location-country-counts' }],
        };

        const endpoints = endpointMap[code];
        if (!endpoints) return;

        try {
            const results: any = {};
            for (const ep of endpoints) {
                const response = await axiosClient().get(`${process.env.REACT_APP_WIDGET_API_SERVER}/widgetInfo/${ep.url}${instituteQry}`);
                results[ep.key] = response.data;
                dispatch({
                    type: 'SET_INTERNAL_STATE',
                    payload: { key: ep.key, value: response.data },
                });
            }

            if (code === 'top_companies' && results.top_company_list) {
                const popupData = getMultiAssociativeArray(results.top_company_list, 'industryCode');
                props.dispatch({
                    type: 'CONTROL_VALUE_CHANGE',
                    payload: { dataKey: 'popupData', value: popupData },
                });
            }
            if (code === 'top_colleges' && results.top_college_list) {
                const popupData = getMultiAssociativeArray(results.top_college_list, 'countryCode');
                props.dispatch({
                    type: 'CONTROL_VALUE_CHANGE',
                    payload: { dataKey: 'popupData', value: popupData },
                });
            }

            const newMetricData = rebuildMetricDataFromCounts(props.state.data?.metricData, results[code], code);
            props.dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'metricData', value: newMetricData },
            });

            setTimeout(() => {
                switch (code) {
                    case 'top_companies':
                    case 'top_colleges':
                        triggerGridDataOnChange(newMetricData, 'metricData', 'metricEntity2');
                        break;
                    case 'directory_stats':
                        triggerGridDataOnChange(newMetricData, 'metricData', 'statMetricEntity');
                        break;
                    default:
                        triggerGridDataOnChange(newMetricData, 'metricData', 'metricEntity');
                }
            }, 500);
        } catch (err) {
            console.error('Error in onProgramChange:', err);
        }
    }

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <WidgetConfigurationLayout state={state} >{!state.flags.isDataLoading && <PageBuilder />}</WidgetConfigurationLayout>
            {code == 'top_companies' && <ListPopup id="top_companies_list" />}
            {code == 'top_companies' && <AddPopup id="add_company" />}
            {code == 'top_colleges' && <ListPopup id="top_colleges_list" />}
            {code == 'top_colleges' && <AddPopup id="add_college" />}
        </SmartContext.Provider>
    );
};

export default WidgetConfiguration;
